import Vue from 'vue';
import dayjs from 'dayjs';

Vue.filter('dateFormat', (timeStamp: Date | null) => {
  if (timeStamp) {
    return dayjs(timeStamp).format('YYYY/MM/DD');
  } else return null;
});

Vue.filter('datetimeFormat', (timestamp: Date | null) => {
  if (timestamp) {
    return dayjs(timestamp).format('YYYY/MM/DD HH:mm');
  } else return null;
})

/** 課題詳細画面の期限日表示に使用 */
Vue.filter('timeFormat', (timeStamp: Date | null) => {
  if (timeStamp) {
    return dayjs(timeStamp).format('HH:MM');
  } else return null;
});

/**UNIXタイムスタンプをUTCに変換 */
Vue.filter('unixFormat', (timeStamp: number | null) => {
  if (timeStamp) {
    return dayjs.unix(timeStamp).format('YYYY/MM/DD');
  } else return null;
});

/**UNIXタイムスタンプをUTCに変換 ブランチ詳細画面で使用 */
Vue.filter('unixTimeSecondsFormat', (timeStamp: number | null) => {
  if (timeStamp) {
    return dayjs.unix(timeStamp).format('YYYY/MM/DD HH:MM');
  } else return null;
});